__turbopack_context__.v({
  "item": "DashboardListSidebar-module__7vrQAa__item",
  "itemMeta": "DashboardListSidebar-module__7vrQAa__itemMeta",
  "newButton": "DashboardListSidebar-module__7vrQAa__newButton",
  "root": "DashboardListSidebar-module__7vrQAa__root",
  "section": "DashboardListSidebar-module__7vrQAa__section",
});
